const config = require('config')

export default function(myApp) {

    myApp.config(['$authProvider', 'RestangularProvider', function($authProvider, RestangularProvider) {
        $authProvider.configure({
            apiUrl: config.END_POINT,
            storage: 'localStorage'
        });
    }]);

}



// WEBPACK FOOTER //
// ./js/auth.js